import { AppConfigKey_FE } from '@nu-art/thunderstorm-frontend/index';
import { ConfigKey_FAQ_ParentOrder } from '@app/advisor-ui-shared';
export const ConfigKeyFE_FAQ_ParentOrder = new AppConfigKey_FE(ConfigKey_FAQ_ParentOrder);
//# sourceMappingURL=app-config.js.map